import React, { FC } from 'react';

export const OfferDescriptionContent: FC = ({ children }) => (
  <p className="offer-description-content-grid text-grey-2 text-sm">
    {children}
  </p>
);

export default OfferDescriptionContent;
